// useUI — guarded access to the UI/selection context (US-874 · R-9).
import { useContext } from "react";
import { UIContext } from "../contexts/UIContext";

const useUI = () => {
  const ctx = useContext(UIContext);
  if (ctx === null) {
    throw new Error("useUI must be used within a <UIProvider>.");
  }
  return ctx;
};

export default useUI;
